import { isArray } from 'lodash';

export const LIST_RESTRICTION_DATA = {
  BOL: 'BOL',
  VALUES_USD: 'VALUES_USD',
};

const PROVISION_RESTRICTION = {
  [LIST_RESTRICTION_DATA.BOL]: ['AR'],
  [LIST_RESTRICTION_DATA.VALUES_USD]: [''],
};

export function useProvisionRestriction() {
  const checkRestriction = ({ countryCode, typeData }: { countryCode: string; typeData: string }) => {
    if (typeData === LIST_RESTRICTION_DATA.BOL) return true; // ALways show tooltip for empty BOL number
    return isArray(PROVISION_RESTRICTION[typeData]) && countryCode && PROVISION_RESTRICTION[typeData].includes(countryCode);
  };
  return { checkRestriction };
}
